export default __webpack_public_path__ + "a7d6a5993fc6d96a0539b3658e6d94de.png";